import { FC } from 'react';
import { Badge } from '@components/atoms/Badge';
import { useTranslation } from '@hooks/useTranslation';
import { CrewHourEntry } from '@models/dailySiteReport.model';

/** Compact Name / Hours table (story-206). "Still on site" is a success badge in the hours cell. */
export const CrewHoursTable: FC<{ entries: CrewHourEntry[] }> = ({ entries }) => {
  const t = useTranslation('dailySiteReport');
  return (
    <table className="w-full text-sm" data-testid="crew-hours-table">
      <thead>
        <tr className="text-left text-xs text-gray-500 border-b border-gray-200 dark:border-gray-700">
          <th className="py-1 font-medium">{t.tableName}</th>
          <th className="py-1 font-medium text-right">{t.tableHours}</th>
        </tr>
      </thead>
      <tbody>
        {entries.map((e) => (
          <tr key={e.userId} className="border-b border-gray-100 dark:border-gray-800 last:border-0">
            <td className="py-1">
              {e.userName}
              {e.adjusted && <span className="text-gray-500"> {t.adjusted}</span>}
            </td>
            <td className="py-1 text-right tabular-nums">
              {e.stillOnSite ? (
                <Badge size="sm" variant="success">
                  {t.stillOnSite}
                </Badge>
              ) : (
                t.hoursValue.replace('{n}', String(e.hours ?? 0))
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CrewHoursTable;
